import axios from 'axios';
import {QrBatchType, QrTable} from "@/scripts/types/qr";

interface BatchQr {
    type: QrBatchType,
    pixel?: string,
    style: any,
    data: QrTable | File
}

export interface BatchQrResultRow {
    row: string
    error: string
}

export interface BatchQrResult {
    createdCount: number,
    errors: BatchQrResultRow[]
}

export const saveBatchQr = async (request: BatchQr) => {
    const url = `/api/qrcode/batch`;

    return (await axios.post(url, request)).data as BatchQrResult;
};
